<template>
    <AppLayout :contrast="true" title="Editar sucursal">
        <Breadcrumb
            name="Sucursales"
            routeName="sucursales"
            page="Editar sucursal"
        />

        <form class="p-2">
            <div class="flex flex-col w-full">
                <div
                    class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:max-w-3xl"
                >
                    <div class="font-medium text-gray-600 text-lg mb-2">
                        Datos básicos
                    </div>
                    <div class="flex flex-col lg:space-x-8 lg:flex-row">
                        <div class="lg:w-1/2">
                            <div class="flex flex-col h-24">
                                <label for="nombre" class="my-1 text-gray-700">
                                    Nombre<span class="text-red-400">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="nombre"
                                    :class="[
                                        't-input',
                                        form.errors.nombre && 't-input-invalid',
                                    ]"
                                    v-model="form.nombre"
                                    required
                                    @focus="form.errors.nombre = null"
                                />
                                <small
                                    v-if="form.errors.nombre"
                                    id="nombre-help"
                                    class="p-error"
                                >
                                    {{ form.errors.nombre }}
                                </small>
                            </div>
                            <div class="flex flex-col h-24">
                                <label
                                    for="cliente_id"
                                    class="my-1 text-gray-700"
                                    >Cliente<span class="text-red-400"
                                        >*</span
                                    ></label
                                >
                                <!-- <select
                                    id="cliente_id"
                                    class="t-select"
                                    v-model="form.cliente_id"
                                    required
                                >
                                    <option selected="selected" disabled>
                                        Seleccionar
                                    </option>
                                    <option
                                        v-for="cliente in clientes"
                                        :value="cliente.id"
                                        :key="cliente.id"
                                    >
                                        {{ cliente.nombre }}
                                    </option>
                                </select> -->
                                <Dropdown
                                    v-model="form.cliente_id"
                                    :options="clientes"
                                    optionLabel="nombre"
                                    optionValue="id"
                                    placeholder="Seleccionar"
                                    :showClear="true"
                                    class="h-[42px] flex items-center"
                                />
                                <small
                                    v-if="form.errors.cliente_id"
                                    id="cliente_id-help"
                                    class="p-error"
                                >
                                    {{ form.errors.cliente_id }}
                                </small>
                            </div>
                            <div class="flex flex-col h-24">
                                <label
                                    for="codigo_sucursal"
                                    class="my-1 text-gray-700"
                                >
                                    Codigo de sucursal<span class="text-red-400"
                                        >*</span
                                    >
                                </label>
                                <input
                                    type="name"
                                    id="codigo"
                                    :class="[
                                        't-input',
                                        form.errors.codigo_sucursal &&
                                            't-input-invalid',
                                    ]"
                                    v-model="form.codigo_sucursal"
                                    required
                                    @focus="form.errors.codigo_sucursal = null"
                                />
                                <small
                                    v-if="form.errors.codigo_sucursal"
                                    id="codigo_sucursal-help"
                                    class="p-error"
                                >
                                    {{ form.errors.codigo_sucusal }}
                                </small>
                            </div>
                            <div class="flex flex-col h-24">
                                <label
                                    for="contacto"
                                    class="my-1 text-gray-700"
                                >
                                    Contacto
                                </label>
                                <input
                                    type="text"
                                    id="contacto"
                                    :class="['t-input']"
                                    v-model="form.contacto"
                                />
                            </div>
                        </div>
                        <div class="lg:w-1/2">
                            <div class="flex flex-col h-24">
                                <label for="email" class="my-1 text-gray-700">
                                    Email
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    :class="['t-input']"
                                    v-model="form.email"
                                />
                            </div>
                            <div class="flex flex-col h-24">
                                <label
                                    for="documento"
                                    class="my-1 text-gray-700"
                                >
                                    Nro. de documento
                                </label>
                                <input
                                    type="text"
                                    id="documento"
                                    :class="['t-input']"
                                    v-model="form.documento"
                                />
                            </div>
                            <div class="flex flex-col h-24">
                                <label
                                    for="telefono"
                                    class="my-1 text-gray-700"
                                >
                                    Telefono
                                </label>
                                <input
                                    type="tel"
                                    id="telefono"
                                    :class="['t-input']"
                                    v-model="form.telefono"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:max-w-3xl"
                >
                    <div class="font-medium text-gray-600 text-lg mb-2">
                        Datos de dirección
                    </div>
                    <div class="flex flex-col lg:space-x-8 lg:flex-row">
                        <div class="lg:w-1/2">
                            <div class="flex flex-col h-24">
                                <label for="cp" class="my-1 text-gray-700">
                                    Codigo Postal<span class="text-red-400"
                                        >*</span
                                    >
                                </label>
                                <input
                                    type="text"
                                    id="cp"
                                    :class="[
                                        't-input',
                                        form.errors.cp && 't-input-invalid',
                                    ]"
                                    v-model="form.cp"
                                    required
                                    @focus="form.errors.cp = null"
                                />
                                <small
                                    v-if="form.errors.cp"
                                    id="cp-help"
                                    class="p-error"
                                >
                                    {{ form.errors.cp }}
                                </small>
                            </div>
                            <div class="flex flex-col h-24">
                                <label for="calle" class="my-1 text-gray-700">
                                    Calle<span class="text-red-400">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="calle"
                                    :class="[
                                        't-input',
                                        form.errors.calle && 't-input-invalid',
                                    ]"
                                    v-model="form.calle"
                                    required
                                    @focus="form.errors.calle = null"
                                />
                                <small
                                    v-if="form.errors.calle"
                                    id="calle-help"
                                    class="p-error"
                                >
                                    {{ form.errors.calle }}
                                </small>
                            </div>
                            <div class="flex flex-col h-24">
                                <label for="calle" class="my-1 text-gray-700">
                                    Altura<span class="text-red-400">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="altura"
                                    :class="[
                                        't-input',
                                        form.errors.altura && 't-input-invalid',
                                    ]"
                                    v-model="form.altura"
                                    required
                                    @focus="form.errors.altura = null"
                                />
                                <small
                                    v-if="form.errors.altura"
                                    id="altura-help"
                                    class="p-error"
                                >
                                    {{ form.errors.altura }}
                                </small>
                            </div>
                            <div class="flex flex-col h-24">
                                <label for="piso" class="my-1 text-gray-700">
                                    Piso
                                </label>
                                <input
                                    type="text"
                                    id="piso"
                                    :class="['t-input']"
                                    v-model="form.piso"
                                />
                            </div>
                        </div>
                        <div class="lg:w-1/2">
                            <div class="flex flex-col h-24">
                                <label for="dpto" class="my-1 text-gray-700">
                                    Dpto.
                                </label>
                                <input
                                    type="text"
                                    id="dpto"
                                    :class="['t-input']"
                                    v-model="form.dpto"
                                />
                            </div>
                            <div class="flex flex-col h-24">
                                <label
                                    for="localidad"
                                    class="my-1 text-gray-700"
                                >
                                    Localidad<span class="text-red-400">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="localidad"
                                    :class="[
                                        't-input',
                                        form.errors.localidad &&
                                            't-input-invalid',
                                    ]"
                                    v-model="form.localidad"
                                    required
                                    @focus="form.errors.localidad = null"
                                />
                                <small
                                    v-if="form.errors.localidad"
                                    id="localidad-help"
                                    class="p-error"
                                >
                                    {{ form.errors.localidad }}
                                </small>
                            </div>
                            <div class="flex flex-col h-24">
                                <label
                                    for="provincia"
                                    class="my-1 text-gray-700"
                                >
                                    Provincia<span class="text-red-400">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="provincia"
                                    :class="[
                                        't-input',
                                        form.errors.provincia &&
                                            't-input-invalid',
                                    ]"
                                    v-model="form.provincia"
                                    required
                                    @focus="form.errors.provincia = null"
                                />
                                <small
                                    v-if="form.errors.provincia"
                                    id="provincia-help"
                                    class="p-error"
                                >
                                    {{ form.errors.provincia }}
                                </small>
                            </div>
                            <div class="flex flex-col h-24">
                                <label for="pais" class="my-1 text-gray-700">
                                    Pais<span class="text-red-400">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="pais"
                                    :class="[
                                        't-input',
                                        form.errors.pais && 't-input-invalid',
                                    ]"
                                    v-model="form.pais"
                                    required
                                    @focus="form.errors.pais = null"
                                />
                                <small
                                    v-if="form.errors.pais"
                                    id="pais-help"
                                    class="p-error"
                                >
                                    {{ form.errors.pais }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:max-w-3xl"
                >
                    <div class="font-medium text-gray-600 text-lg mb-2">
                        Configuración
                    </div>

                    <div class="flex flex-col lg:space-x-8 lg:flex-row">
                        <div class="lg:w-1/2">
                            <div class="flex flex-col h-24">
                                <label
                                    for="porcentaje_precio_factura"
                                    class="my-1 text-gray-700"
                                >
                                    % Precio a facturar
                                </label>
                                <input
                                    type="number"
                                    id="porcentaje_precio_factura"
                                    :class="['t-input']"
                                    v-model="form.porcentaje_precio_factura"
                                />
                            </div>
                            <div class="flex flex-col h-24">
                                <label
                                    for="porcentaje_precio_mostrado"
                                    class="my-1 text-gray-700"
                                >
                                    % Precio mostrado
                                </label>
                                <input
                                    type="number"
                                    id="porcentaje_precio_mostrado"
                                    :class="['t-input']"
                                    v-model="form.porcentaje_precio_mostrado"
                                />
                            </div>
                            <div class="flex flex-col h-24">
                                <label
                                    for="porcentaje_seguro"
                                    class="my-1 text-gray-700"
                                >
                                    Porcentaje de seguro
                                </label>
                                <input
                                    type="number"
                                    id="porcentaje_seguro"
                                    :class="['t-input']"
                                    v-model="form.porcentaje_seguro"
                                />
                            </div>
                            <br>
                            <div class="h-24 flex flex-col justify-center">
                                <div class="flex items-center mb-4">
                                    <input
                                        id="multiple_etiqueta"
                                        aria-describedby="multiple_etiqueta"
                                        type="checkbox"
                                        class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                                        v-model="form.multiple_etiqueta"
                                    />
                                    <label
                                        for="multiple_etiqueta"
                                        class="ml-3 text-sm text-gray-700"
                                        >Multiple etiqueta
                                    </label>
                                </div>
                                <div class="flex items-center mb-4">
                                    <input
                                        id="listo_para_recolectar_automatico"
                                        aria-describedby="listo_para_recolectar_automatico"
                                        type="checkbox"
                                        class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                                        v-model="form.listo_para_recolectar_automatico"
                                    />
                                    <label
                                        for="listo_para_recolectar_automatico"
                                        class="ml-3 text-sm text-gray-700"
                                        >Listo para recolectar automatico
                                        <span
                                            v-tooltip.right="
                                                'Todos los envios de esta sucursal se marcaran como listo para recolectar automaticamente al ser creados'
                                            "
                                            class="border-gray-700 border-b-2 border-dotted text-[12px]"
                                            >?</span
                                        >
                                    </label>
                                </div>
                                <div class="flex items-center mb-4">
                                    <input
                                        id="deposito"
                                        aria-describedby="deposito"
                                        type="checkbox"
                                        class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                                        v-model="form.deposito"
                                    />
                                    <label
                                        for="deposito"
                                        class="ml-3 text-sm text-gray-700"
                                        >Posee deposito de proveedor
                                        <span
                                            v-tooltip.right="
                                                'Se notificara al proveedor con deposito sobre los envios recientes'
                                            "
                                            class="border-gray-700 border-b-2 border-dotted text-[12px]"
                                            >?</span
                                        >
                                    </label>
                                </div>
                                <div class="flex items-center mb-4">
                                    <input
                                        id="paquete_definido"
                                        aria-describedby="paquete_definido"
                                        type="checkbox"
                                        class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                                        v-model="form.paquete_definido"
                                    />
                                    <label
                                        for="paquete_definido"
                                        class="ml-3 text-sm text-gray-700"
                                        >Paquete definido
                                    </label>
                                </div>
                            </div>
                            <br>
                            <div class="flex flex-col h-24">
                                <label for="ancho" class="my-1 text-gray-700">
                                    Ancho
                                </label>
                                <input
                                    type="number"
                                    id="ancho"
                                    :class="[
                                        form.paquete_definido
                                            ? 't-input'
                                            : 't-input-disabled',
                                    ]"
                                    :required="form.paquete_definido"
                                    v-model="form.ancho"
                                    :disabled="!form.paquete_definido"
                                />
                            </div>
                            <div class="flex flex-col h-24">
                                <label for="largo" class="my-1 text-gray-700">
                                    Largo
                                </label>
                                <input
                                    type="number"
                                    id="largo"
                                    :class="[
                                        form.paquete_definido
                                            ? 't-input'
                                            : 't-input-disabled',
                                    ]"
                                    :required="form.paquete_definido"
                                    v-model="form.largo"
                                    :disabled="!form.paquete_definido"
                                />
                            </div>
                            <div class="flex flex-col h-24">
                                <label for="alto" class="my-1 text-gray-700">
                                    Alto
                                </label>
                                <input
                                    type="number"
                                    id="alto"
                                    :class="[
                                        form.paquete_definido
                                            ? 't-input'
                                            : 't-input-disabled',
                                    ]"
                                    :required="form.paquete_definido"
                                    v-model="form.alto"
                                    :disabled="!form.paquete_definido"
                                />
                            </div>
                        </div>
                        <div class="lg:w-1/2">
                            <div class="flex flex-col h-24">
                                <div class="flex items-center mb-4">
                                    <input
                                        id="envio_gratis_checkbox"
                                        aria-describedby="envio_gratis_checkbox"
                                        type="checkbox"
                                        class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                                        v-model="envio_gratis_checkbox"
                                    />
                                    <label
                                        for="envio_gratis_checkbox"
                                        class="ml-3 text-sm text-gray-700"
                                        >Envio gratis
                                    </label>
                                </div>
                                <input
                                    :disabled="!envio_gratis_checkbox"
                                    v-tooltip.right.focus="
                                        'Monto en pesos (ARS) a partir del cual el envio es gratis'
                                    "
                                    type="number"
                                    id="envio_gratis"
                                    :class="[
                                        envio_gratis_checkbox
                                            ? 't-input'
                                            : 't-input-disabled',
                                    ]"
                                    v-model="form.envio_gratis"
                                />
                            </div>
                            <div class="flex flex-col h-24">
                                <label
                                    for="observacion"
                                    class="my-1 text-gray-700"
                                >
                                    Observaciones
                                </label>
                                <input
                                    type="text"
                                    id="observacion"
                                    :class="['t-input']"
                                    v-model="form.observacion"
                                />
                            </div>

                            <div class="flex flex-col h-12">
                                <div class="flex items-center mb-2">
                                    <input
                                        id="con_proveedor_pickup"
                                        aria-describedby="con_proveedor_pickup"
                                        type="checkbox"
                                        class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                                        v-model="form.con_proveedor_pickup"
                                    />
                                    <label
                                        for="con_proveedor_pickup"
                                        class="ml-3 text-sm text-gray-700"
                                        >Sucursal trabajara con un segundo proveedor que realice las recolecciones? (pickup)
                                    </label>
                                </div>
                            </div>

                            <div class="flex flex-col h-24">
                                <label
                                    for="pickup_proveedor_id"
                                    class="my-1 text-gray-700"
                                    >
                                    Proveedor de recolección
                                </label>
                                <Dropdown
                                    v-model="form.pickup_proveedor_id"
                                    :options="proveedores"
                                    :disabled="!form.con_proveedor_pickup"
                                    optionLabel="nombre"
                                    optionValue="id"
                                    placeholder="Seleccionar"
                                    :showClear="true"
                                    class="h-[42px] flex items-center"
                                />
                                <small
                                    v-if="form.errors.pickup_proveedor_id"
                                    id="pickup_proveedor_id-help"
                                    class="p-error"
                                >
                                    {{ form.errors.pickup_proveedor_id }}
                                </small>
                            </div>

                            <div class="flex flex-col">
                                <div class="my-1 text-gray-700 mb-4">
                                    Proveedores habilitados
                                </div>
                                <div class="flex items-center gap-x-5 mb-4">
                                    <div class="w-40"></div>
                                    <div class="text-sm text-gray-700"> Activo </div>
                                    <div class="text-sm text-gray-700"> Usa pickup </div>
                                </div>
                                <div v-for="proveedor in checked_proveedores" :key="proveedor.id">
                                    <div class="flex items-center gap-x-5 mb-4">
                                        <div class="w-40 ml-3 text-sm text-gray-700">{{ proveedor.nombre }}</div>
                                        <div class="w-10">
                                            <input type="checkbox"
                                                class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                                                v-model="proveedor.activo"
                                                @click="() => proveedor.usa_pickup = false"> 
                                        </div>
                                        <div class="w-10">
                                            <input type="checkbox"
                                                class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                                                v-model="proveedor.usa_pickup"
                                                :disabled="!proveedor.activo">
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="flex items-center mb-4">
                                    <ul>
                                        <li
                                            v-for="item in proveedores"
                                            :value="item.id"
                                            :key="item.id"
                                            class="mb-4"
                                        >
                                            <input
                                                type="checkbox"
                                                :id="item.nombre"
                                                :value="item.id"
                                                aria-describedby="envio_gratis"
                                                class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                                                v-model="
                                                    form.checked_proveedores
                                                "
                                            />
                                            <input
                                                type="checkbox"
                                                :id="item.nombre"
                                                :value="item.id"
                                                aria-describedby="envio_gratis"
                                                class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                                                v-model="
                                                    form.checked_proveedores
                                                "
                                            />
                                            <label
                                                :for="item.nombre"
                                                class="ml-3 text-sm text-gray-700"
                                            >
                                                {{ item.nombre }}
                                            </label>
                                            <br />
                                        </li>
                                    </ul>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="my-1 text-gray-700 mb-4">
                            Cordones habilitados
                        </div>
                        <ul class="lg:grid grid-cols-2">
                            <li
                                v-for="cordon in cordones"
                                :value="cordon.id"
                                :key="cordon.id"
                                class="mb-4"
                            >
                                <input
                                    type="checkbox"
                                    :id="cordon.descripcion.replaceAll(' ', '_')"
                                    :value="cordon.id"
                                    class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                                    v-model="
                                        form.checked_cordones
                                    "
                                />
                                <label
                                    :for="cordon.descripcion.replaceAll(' ', '_')"
                                    class="ml-3 text-sm text-gray-700"
                                >
                                    {{ cordon.descripcion }}
                                </label>
                                <br />
                            </li>
                        </ul>
                    </div>
                    <div class="">
                        <div class="font-medium text-gray-600 text-lg mb-2">
                            Información de Email
                        </div>
                        <ckeditor :editor="editor" v-model="form.contenido_email" :config="editorConfig"></ckeditor>
                    <br>
                    </div>
                    <div class="flex items-center mb-4">
                        <input
                            id="aprobacion_email"
                            aria-describedby="aprobacion_email"
                            type="checkbox"
                            class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                            v-model="form.aprobacion_email"
                        />
                        <label
                            for="aprobacion_email"
                            class="ml-3 text-sm text-gray-700"
                            >Aprobación Email
                        </label>
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="api_token" class="my-1 text-gray-700">
                            Token API
                        </label>
                        <input
                            type="text"
                            id="api_token"
                            v-model="form.api_token"
                            disabled
                            :class="['t-input']"
                        />
                    </div>
                </div>
            </div>
            <div class="m-4 flex justify-end lg:max-w-3xl">
                <Button @click.prevent="actu_token"> Refrescar Token </Button>
                <Link :href="route('credenciales.edit', sucursal.id)">
                    <Button> Gestionar credenciales </Button>
                </Link>
                <Button @click.prevent="update"> Editar sucursal </Button>
            </div>
        </form>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { Inertia } from "@inertiajs/inertia";
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { AngleRight } from "@vicons/fa";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue";

export default {
    components: {
        AppLayout,
        Link,
        Icon,
        AngleRight,
        Breadcrumb,
        Button,
        ckeditor: CKEditor.component,
    },
    props: {
        sucursal: Object,
        clientes: Array,
        proveedores: Array,
        checked_proveedores: Array,
        cordones: Array,
        checked_cordones: Array,
    },
    data() {
        return {
            envio_gratis_checkbox: false,
            editor: ClassicEditor,
            editorConfig: {
                toolbar: {
                    items: [
                        'heading', '|',
                        'fontfamily', 'fontsize', '|',
                        'alignment', '|',
                        'fontColor', 'fontBackgroundColor', '|',
                        'bold', 'italic', 'strikethrough', 'underline', 'subscript', 'superscript', '|',
                        'link', '|',
                        'outdent', 'indent', '|',
                        'bulletedList', 'numberedList', 'todoList', '|',
                        'code', 'codeBlock', '|',
                        'insertTable', '|',
                        'undo', 'redo'
                    ],
                    shouldNotGroupWhenFull: true
                }
            },
            form: this.$inertia.form({
                checked_proveedores: this.checked_proveedores,
                // c_p: [{id: 12, activo: false, usa_pickup: false}]
                checked_cordones: this.checked_cordones,
                con_proveedor_pickup: null,
                pickup_proveedor_id: this.sucursal.pickup_proveedor_id,
                cliente_id: this.sucursal.cliente_id,
                codigo_sucursal: this.sucursal.codigo_sucursal,
                contacto: this.sucursal.contacto,
                razon_social: this.sucursal.razon_social,
                nombre: this.sucursal.nombre,
                documento: this.sucursal.documento,
                telefono: this.sucursal.telefono,
                email: this.sucursal.email,
                cp: this.sucursal.cp,
                calle: this.sucursal.calle,
                altura: this.sucursal.altura,
                piso: this.sucursal.piso,
                dpto: this.sucursal.dpto,
                localidad: this.sucursal.localidad,
                provincia: this.sucursal.provincia,
                pais: this.sucursal.pais,
                observacion: this.sucursal.observacion,
                deposito: this.sucursal.deposito === 1 ? true : false,
                envio_gratis: this.sucursal.envio_gratis,
                porcentaje_seguro: this.sucursal.porcentaje_seguro,
                porcentaje_precio_factura:
                    this.sucursal.porcentaje_precio_factura,
                porcentaje_precio_mostrado:
                    this.sucursal.porcentaje_precio_mostrado,
                paquete_definido:
                    this.sucursal.paquete_definido === 1 ? true : false,
                multiple_etiqueta:
                    this.sucursal.multiple_etiqueta === 1 ? true : false,
                listo_para_recolectar_automatico:
                    this.sucursal.listo_para_recolectar_automatico === 1 ? true : false,
                alto: this.sucursal.alto,
                largo: this.sucursal.largo,
                alto: this.sucursal.alto,
                ancho: this.sucursal.ancho,
                api_token: this.sucursal.api_token,
                contenido_email: this.sucursal.contenido_email,
                aprobacion_email: this.sucursal.aprobacion_email === 1 ? true : false,
            }),
        };
    },
    mounted() {
        if (this.sucursal.envio_gratis !== null) {
            this.envio_gratis_checkbox = true;
        }
        if (this.sucursal.pickup_proveedor_id !== null) {
            this.form.con_proveedor_pickup = true;
        }
    },
    computed: {
        paqueteDefinido() {
            return this.form.paquete_definido;
        },
    },
    watch: {
        paqueteDefinido(newState) {
            if (newState === false) {
                this.clearDimensions();
            }
        },
        envio_gratis_checkbox(newState) {
            if (newState === false) {
                this.form.envio_gratis = null;
            }
        },
        'form.con_proveedor_pickup'(newState) {
            if (newState === false) {
                this.form.pickup_proveedor_id = null;
            }
        }
    },
    methods: {
        update() {
            this.form.put("/sucursales/" + this.sucursal.id);
        },
        actu_token() {
            this.form.put("/sucursales/token/" + this.sucursal.id, {
                onSuccess: () => {
                    Inertia.reload({
                        only: ["sucursal"],
                    });
                    this.form.api_token = this.sucursal.api_token;
                }
            });
        },
        clearDimensions() {
            this.form.alto = "";
            this.form.largo = "";
            this.form.ancho = "";
        },
    },
};
</script>

<style scoped>
.p-inputtext:enabled:focus,
.p-password-input:enabled:focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}
.p-inputtext:hover,
.p-password-input:hover {
    border-color: #829fc1;
}
</style>
